import { render, staticRenderFns } from "./tagSubscribeRecord.vue?vue&type=template&id=787bd3a6&scoped=true"
import script from "./tagSubscribeRecord.vue?vue&type=script&lang=js"
export * from "./tagSubscribeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bd3a6",
  null
  
)

export default component.exports